import type { GameRowValue } from "../../../backend.d.ts"
import type { LobbyRowValue } from "../../../backend.d.ts"
import type { MapRowValue } from "../../../backend.d.ts"
import { modifyMutable, produce, unwrap } from "solid-js/store"
import type { Nullable } from "../../../typescript"
import { deepClone } from "../../deep_clone"
import { useActionLogsSignal } from "../../../rx/signal/useActionLogsSignal"
import { useEnginePrevStateSignal } from "../../../rx/signal/useEnginePrevStateSignal"
import type { Engine } from "./Engine.type"

export default function syncEngineWithPropsRow (engine : Engine, row: Nullable<GameRowValue | MapRowValue | LobbyRowValue>) {
  if (row) {
    const { data, action_logs } = row
    const newState = unwrap(data)
    const setActionLogs = useActionLogsSignal(engine)[1]
    const [, setPrevState] = useEnginePrevStateSignal(engine)
    const clonedState = deepClone(newState)
    const clonedPrevState = deepClone(newState)
    modifyMutable(engine, produce((engine: Engine) => {
      engine.state = clonedState
    }))
    setPrevState(clonedPrevState)
    setActionLogs(deepClone(unwrap(action_logs)) || [])
  }
}
